import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Merges conditional class names, letting a caller's utility win over a component default. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
